import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

export default function Heading({
  children, className, divided, flush, level, levelStyle,
}: props) {
  let Component = 'h2'

  if (level === '1') {
    Component = 'h1'
  } else if (level === '3') {
    Component = 'h3'
  } if (level === '4') {
    Component = 'h4'
  } if (level === '5') {
    Component = 'h5'
  } if (level === '6') {
    Component = 'h6'
  }

  return (
    <Component
      className={classNames(
        'Heading',
        divided && 'uk-heading-divider',
        flush && 'uk-margin-remove-vertical',
        (!levelStyle && level) && `uk-h${level}`,
        levelStyle && `uk-h${levelStyle}`,
        className,
      )}>
      {children}
    </Component>
  )
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  divided: PropTypes.bool,
  flush: PropTypes.bool,
  level: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']),
  levelStyle: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']),
}

Heading.defaultProps = {
  level: '2',
}



// WEBPACK FOOTER //
// ./src/components/Heading/Heading.js